module.exports = __webpack_public_path__ + "static/media/Jasmine Rosen.2955c84e.png";